<template>
  <div class="app-container">
    <div class="title">
      <img src="@/resources/img/ministerio-iet-logo.jpg" class="left" />
      <img src="@/resources/img/aeat-791-logo.png" class="right" />
      <span v-html="$t('message.tasas.titulo' + tipoEmpresa)"></span>
    </div>
    <Divider>
      <v-btn flat small class="ayuda" :to="'/tasas/presentacion-tasa/ayuda' + tipoEmpresa"
        ><v-icon left color="primary">info</v-icon
        >{{
          $t('message.tasas.instrucciones', { tipo: $tc('message.empresa.tipos', tipoMensaje) })
        }}
      </v-btn>
    </Divider>
    <v-form ref="formDeclaracion" lazy-validation>
      <Divider>{{ $t('message.tasas.apartado1') }}</Divider>
      <v-container fluid grid-list-xs>
        <v-layout d-inline-flex>
          <v-flex xs6>
            <v-text-field
              :label="$t('message.comun.mesDeclaracion')"
              v-model="periodoDeclaracionText"
              readonly
            ></v-text-field>
          </v-flex>
          <v-flex xs6>
            <MonthPicker
              id="mesFacturacion"
              v-model="form.mesFacturacion"
              placeholder="mes-año"
              :pickerOptions="allowedMonths"
              :label="$t('message.comun.mesFacturacion')"
            ></MonthPicker>
          </v-flex>
        </v-layout>
      </v-container>
      <Divider>{{ $t('message.tasas.apartado2') }}</Divider>
      <PeriodosConsumo
        id="tblTarifas"
        :data="tarifas"
        :allowEdit="allowEdit"
        :mesFacturacion="form.mesFacturacion"
        @modify="modificarTarifaPeajeaHandler"
        @remove="removeTarifaClickHandler"
      ></PeriodosConsumo>

      <Divider>{{ $t('message.tasas.apartado3') }}</Divider>
      <PeriodosConsumo
        id="tblPeajes"
        :data="peajes"
        :allowEdit="allowEdit"
        :mesFacturacion="form.mesFacturacion"
        @modify="modificarTarifaPeajeaHandler"
        @remove="removeTarifaClickHandler"
      ></PeriodosConsumo>

      <Divider>{{ $t('message.tasas.apartado4') }}</Divider>
      <LiquidacionTasa :data="liquidaciones" v-if="form.mesFacturacion"></LiquidacionTasa>

      <v-layout v-if="form.mesFacturacion">
        <v-flex lg6>
          <Divider>{{ $t('message.tasas.apartado5') }}</Divider>
          <v-container fluid grid-list-lg>
            <v-layout wrap>
              <v-flex xs12 sm12 md12 lg4>
                <v-text-field
                  :label="$t('message.comun.nif')"
                  v-model="userNIFCIF"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md12 lg6>
                <v-text-field
                  :label="$t('message.comun.nombre')"
                  v-model="userName"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md12 lg10>
                <v-text-field
                  :label="$t('message.comun.fecha')"
                  v-model="fechaActual"
                  readonly
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>

        <v-flex lg6>
          <Divider>{{ $t('message.tasas.apartado6') }}</Divider>
          <v-container fluid grid-list-lg>
            <v-layout wrap>
              <v-flex lg12>
                {{
                  $t('message.comun.ingreso', { tipo: $tc('message.home.menu.tasas.titulo', 2) })
                }}
              </v-flex>
              <v-flex xs8 sm6 md4 lg4>
                <Numeric
                  id="importeAIngresar"
                  :label="$t('message.comun.importeTotal')"
                  :value="totalIngresar"
                  currency="€"
                  readonly
                ></Numeric>
              </v-flex>
              <v-flex lg12>
                <v-radio-group
                  v-model="form.resumenes[0].formaPago"
                  :label="$t('message.comun.formaPago')"
                  class="pagoRB"
                  row
                >
                  <v-radio value="E">
                    <div slot="label">{{ $t('message.comun.formaPagos.efectivo') }}</div>
                  </v-radio>
                  <v-radio value="C">
                    <div slot="label">{{ $t('message.comun.formaPagos.cuenta') }}</div>
                  </v-radio>
                </v-radio-group>
              </v-flex>
              <v-flex lg12 v-if="form.resumenes[0].formaPago == 'C'">
                <v-text-field
                  :mask="maskIBAN"
                  v-model="form.resumenes[0].numCuenta"
                  :label="$t('message.comun.cuenta')"
                  :placeholder="maskIBAN"
                  :rules="rules.numCuenta"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex text-xs-center>
          <Boton
            id="btnPresentar"
            :onclick="onSubmitAccept"
            v-if="form.mesFacturacion"
            :deshabilitado="puedePresentar"
            >{{ $t('message.tasas.presentarTasa') }}</Boton
          >
        </v-flex>
      </v-layout>
    </v-form>
    <!-- Ventana modal de alerta -->
    <Modal
      id="modalAvisoTasa"
      :modalShow="showAlert"
      size="400"
      :title="$t('message.tasas.presentarTasa')"
    >
      <p class="negrita text-xs-center">{{ $t('message.tasas.presentarTasaAviso') }}</p>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" flat @click="showAlert = false">
          Cancelar
        </v-btn>
        <v-btn color="primary" @click="onSubmit">
          Enviar
        </v-btn>
      </v-card-actions>
    </Modal>
  </div>
</template>

<script>
// General
import redirect from '@/router/redirect';
import { mapActions, mapGetters } from 'vuex';

// Componentes
import { PeriodosConsumo, LiquidacionTasa } from './components';
import { DatePicker, MonthPicker, Divider, Modal, Numeric, Boton } from '@/components';
// Apis
import { getVigenciaCuotaEmpresa } from '@/api/empresas';
import { newDeclaracion } from '@/api/declaraciones';
// Utils
import {
  TASA_TARIFA,
  TASA_PEAJE,
  TIPO_DECLARACION_TASA,
  tarifasPeajesInit,
  liquidacionesTarifasPeajesInit,
  tasaConst
} from './constTasas';
import { RESUMEN_CUOTA_INIT, empConst } from '@/utils/constants';
import { cloneArray } from '@/utils';
import { notificarError } from '@/utils/notification';
import moment from 'moment';

export default {
  name: 'tasa',
  data() {
    return {
      tarifasPeajes: cloneArray(tarifasPeajesInit),
      liquidacionesTarifasPeajes: cloneArray(liquidacionesTarifasPeajesInit),
      showAlert: false,
      form: {
        idEmpresa: null,
        tipoDeclaracion: TIPO_DECLARACION_TASA,
        mesDeclaracion: null,
        mesFacturacion: null,
        cuotasDeclaracion: [],
        resumenes: []
      },
      pickerOptions: {
        disabledDates: {
          from: moment()
            .startOf()
            .date(0)
            .toDate()
        }
      },
      maskIBAN: 'ES## - #### - #### - ## - ##########',
      rules: {
        numCuenta: [
          v => !!v || 'Campo obligatorio',
          v =>
            (v && v.length == 24) ||
            'Debe indicar el código IBAN junto a los 20 dígitos de la cuenta bancaria'
        ]
      }
    };
  },
  components: {
    PeriodosConsumo,
    DatePicker,
    MonthPicker,
    LiquidacionTasa,
    Divider,
    Modal,
    Numeric,
    Boton
  },
  created() {
    this.setBreadcrumb({
      breadcrumb: [
        { text: 'Inicio', to: '/', disabled: false },
        { text: 'Tasas', to: '/tasas', disabled: false },
        { text: 'Presentar Tasas', to: '/tasas/presentacion-tasa', disabled: true }
      ],
      menuSelected: '/tasas/presentacion-tasa'
    });
    // Se verifica que pueda acceder
    this.checkIntegrity();

    // Se cargar datos iniciales
    this.cargarDatos();
  },
  computed: {
    ...mapGetters(['empresaSelected', 'isGasElectricidad', 'userNIFCIF', 'userName']),
    tipoEmpresa() {
      return this.empresaSelected.cdtipemp;
    },
    tipoMensaje() {
      return this.empresaSelected.cdtipemp === 'E' ? 1 : 2;
    },
    idCurrentTasa() {
      return this.tipoEmpresa === empConst.TIPO_GAS ? tasaConst.ID_TASA_GAS : tasaConst.ID_TASA_ELE;
    },
    periodoDeclaracionText() {
      return this.form.mesDeclaracion
        ? moment(this.form.mesDeclaracion).format('MMMM [de] YYYY')
        : '';
    },
    fechaActual() {
      return moment().format('DD [de] MMMM [de] YYYY');
    },
    allowEdit() {
      if (this.form.mesFacturacion && this.form.mesFacturacion !== '') {
        return true;
      } else {
        return false;
      }
    },
    tarifas() {
      return this.tarifasPeajes.filter(
        item => item.tipoEmpresa === this.tipoEmpresa && item.tipoTasa === TASA_TARIFA
      );
    },
    peajes() {
      return this.tarifasPeajes.filter(
        item => item.tipoEmpresa === this.tipoEmpresa && item.tipoTasa === TASA_PEAJE
      );
    },
    liquidaciones() {
      return this.liquidacionesTarifasPeajes.filter(item => item.tipoEmpresa === this.tipoEmpresa);
    },
    totalIngresar() {
      let totalAIngresar = this.liquidaciones.reduce((total, item) => {
        return total + (item.cuotaTributaria === '' ? 0 : item.cuotaTributaria);
      }, 0);
      totalAIngresar = Math.round10(totalAIngresar, -2);
      return totalAIngresar;
    },
    puedePresentar() {
      // El importe a ingresar debe ser mayor que 0 (teniendo en cuenta que la regularización sólo puede ser negativa)
      return this.totalIngresar == 0;
    }
  },
  methods: {
    ...mapActions(['setLoading', 'setBreadcrumb']),
    allowedMonths(val) {
      return (
        moment(val).toDate() <=
        moment()
          .startOf()
          .date(0)
          .toDate()
      );
    },
    checkIntegrity() {
      if (!this.isGasElectricidad) {
        redirect.toError('Tipo de empresa no permitido');
      }
    },
    cargarDatos() {
      this.setLoading(true);
      // Preparamos el payload
      let payload = {
        idEmpresa: this.empresaSelected.idempres,
        idCuota: this.idCurrentTasa
      };
      getVigenciaCuotaEmpresa(payload)
        .catch(error => {
          if (error.response && error.response.status === 404) {
            redirect.toError(new Error('A esta empresa no se le aplica esta tasa'));
          } else {
            redirect.toError(error);
          }
        })
        .then(() => {
          // Cargamos datos inciales
          this.form.idEmpresa = this.empresaSelected.idempres;
          this.form.mesDeclaracion = moment()
            .startOf('month')
            .toDate();

          // Resumen
          let resumen = {};
          Object.assign(resumen, RESUMEN_CUOTA_INIT);
          resumen.id = this.idCurrentTasa;
          resumen.formaPago = 'E';
          this.form.resumenes.push(resumen);
          this.setLoading(false);
        });
    },
    // Periodo consumo
    modificarTarifaPeajeaHandler(payload) {
      var index = this.tarifasPeajes.findIndex(function(item) {
        return item.id === payload.id;
      });
      Object.assign(this.tarifasPeajes[index], payload);
      // Actualizar liquidacion
      this.actualizarLiquidaciones();
    },
    removeTarifaClickHandler(payload) {
      // hacemos reset
      Object.assign(
        this.tarifasPeajes.filter(item => item.id === payload.id)[0],
        tarifasPeajesInit.filter(item => item.id === payload.id)[0]
      );
      // Actualizamos la liquidación
      this.actualizarLiquidaciones();
    },

    // Liquidaciones
    liquidacionById(id) {
      return this.liquidaciones.filter(item => id.startsWith(item.id))[0];
    },
    actualizarLiquidaciones() {
      //Reseteamos liquidaciones
      this.liquidacionesTarifasPeajes = cloneArray(liquidacionesTarifasPeajesInit);
      for (let liquidacion of this.liquidaciones) {
        liquidacion.cuotaTributaria = this.tarifasPeajes
          .filter(
            item =>
              item.tipoEmpresa === this.tipoEmpresa &&
              item.selected &&
              item.id.startsWith(liquidacion.id)
          )
          .reduce((total, item) => {
            return total + item.cuotaTributaria;
          }, 0);
        if (liquidacion.cuotaTributaria !== 0) {
          // Recuperamos el tipo
          liquidacion.tipo = Math.min.apply(
            Math,
            this.tarifasPeajes
              .filter(
                item =>
                  item.tipoEmpresa === this.tipoEmpresa &&
                  item.selected &&
                  item.id.startsWith(liquidacion.id)
              )
              .map(e => e.tipo)
          );
        }
      }
    },
    onSubmitAccept() {
      this.showAlert = true;
    },
    onSubmit() {
      // Validar formulario
      this.showAlert = false;
      if (this.$refs.formDeclaracion.validate()) {
        this.setLoading(true);
        var self = this;
        this.form.resumenes[0].totalIngresar = this.totalIngresar;
        this.form.resumenes[0].importeRegulado = self.liquidacionById(
          'R' + this.tipoEmpresa
        ).cuotaTributaria;
        // importe total sin regularización
        this.form.resumenes[0].total = this.liquidaciones.reduce((total, item) => {
          return (
            total +
            (item.cuotaTributaria === '' || item.id.startsWith('R') ? 0 : item.cuotaTributaria)
          );
        }, 0);
        this.form.resumenes[0].total = Math.round10(this.form.resumenes[0].total, -2);
        this.form.cuotasDeclaracion = this.tarifasPeajes
          .filter(item => item.selected === true)
          .map(function(obj) {
            var rObj = {};
            rObj['id'] = obj.id;
            rObj['idBaseCo'] = obj.idBaseCo;
            rObj['idCuota'] = obj.idCuota;
            rObj['periodoConsumo'] = obj.periodoConsumo;
            rObj['facturacion'] = obj.facturacion;
            rObj['baseImponible'] = obj.baseImponible;
            rObj['tipo'] = obj.tipo;
            rObj['cuotaTributaria'] = obj.cuotaTributaria;
            return rObj;
          });
        newDeclaracion(JSON.stringify(this.form))
          .then(response => {
            this.$router.push({
              name: 'justificante',
              params: { cdregist: response.data.cdregist, nujustas: response.data.nujustas }
            });
          })
          .catch(error => {
            notificarError(this, error);
          })
          .then(() => {
            this.setLoading(false);
          });
      }
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import 'src/resources/styles/variables.scss';
.title {
  font-size: 1.4rem;
  font-weight: 500;
  line-height: 1.5;
  text-align: center;
  min-height: 90px;

  img.left {
    float: left;
    width: 90px;
  }

  img.right {
    float: right;
    width: 190px;
  }
}

.v-form > .container > .layout > .flex {
  padding: 8px;
}

.ayuda {
  margin: 0px;
  font-size: 0.875rem;
  font-weight: bold;
  width: 100%;
}
</style>
